import { useGetServicePrice } from "modules/Booking/common/hooks"

export function useSkipPayment() {
    const [, discountPrice] = useGetServicePrice()
    return discountPrice === 0
}
